// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-table-filters{margin-bottom:var(--ev-padding-xlarge)}`, "",{"version":3,"sources":["webpack://./src/components/users-table-filters/UsersTableFilters.scss"],"names":[],"mappings":"AAAA,qBACC,sCAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
